import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@chakra-ui/react";
import React from "react";
const AppSkeleton = ({ children }) => (_jsx(Box, Object.assign({ minHeight: "100vh", display: "flex", flexDirection: "column" }, { children: children })));
export default AppSkeleton;
